import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="spinner" style={{ margin: '100px auto' }}></div>;
  return user ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
